window.addEventListener('load', () => {
  try {
    document.querySelectorAll('.block--benefits')?.forEach(block => {
      let descriptionHeights = [];
      let titleHeights = [];
 
      // Collect heights inside this block only
      block.querySelectorAll('.benefits-card-description')?.forEach(desc => {
        descriptionHeights?.push(desc.clientHeight);
      });
 
      block.querySelectorAll('.benefits-card-wrap')?.forEach(title => {
        titleHeights?.push(title.clientHeight);
      });
 
      // Get max heights for this block
      let maxDescHeight = Math.max(...descriptionHeights, 0);
      let maxTitleHeight = Math.max(...titleHeights, 0);
 
      // Apply only within this block
      $(block)?.find('.benefits-card-description')?.height(maxDescHeight);
      $(block)?.find('.benefits-card-wrap')?.height(maxTitleHeight);
    });
  } catch (error) {
    console.error('Error initializing benefits equalizer:', error);
  }
});